import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TransactionDetailsStyle = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      background: "#FFFFFF",
      alignItems: "center",
    },
    dateContainer: {
      margin: "24px 0px 12px 14px",
    },
    dateText: {
      color: "#7b858b",
      fontWeight: 600,
    },
    topPanel: {
      background: "#EAEAEA",
      height: "fit-content",
      alignItems: "center",
      padding: "16px 14px",
      borderRadius: "15px 15px 0px 0px",
    },
    title: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightBold,
      linebreak: "anywhere !important",
    },
    skinnyTitle: {
      fontSize: "14px",
      fontWeight: theme.typography.fontWeightRegular,
      linebreak: "anywhere !important",
    },
    description: {
      fontSize: "14px",
      fontWeight: theme.typography.fontWeightRegular,
      color: "#545454",
    },
    time: {
      fontSize: "14px",
    },
    topContainer: {
      padding: "20px",
    },
    tradePanel: {
      gridColumn: "1 / 3",
      gridRow: "1 / 3",
      justifySelf: "start",
    },
    iconStyle: {
      borderRadius: "50%",
      width: "32px",
      height: "32px",
    },
    expanded: {
      position: "unset",
      "&$expanded": {
        margin: "0px",
        boxShadow: "none",
      },

      padding: "16px 14px",
    },
    accordionDetails: {
      borderBottom: "1px solid #d1d4d6",
    },
    button: {
      color: "#FFFFFF",
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      marginTop: "12px",
      width: "100%",
      height: "48px",
      transition: "background 0.5s, color 0.5s",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
    saveNoteText: {
      color: "#FFFFFF",
      fontSize: "16px",
      lineHeight: "19px",
      textAlign: "left",
    },
  }),
);
